import { AxiosRequestConfig } from "axios";
import { OrderL, Order } from "../../type";
import { ResponseT } from "@utils/api/base";
import { Orders } from "@utils/api";
import { handleError } from "@utils/misc";
import useCognito from "@as_core/account/useCognito";

const useOrders = () => {
  const { getToken } = useCognito();

  const getOrders = async (token, params): Promise<ResponseT<OrderL>> => {
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Orders.all(token, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  const getOrder = async (
    orderId,
    params = null
  ): Promise<ResponseT<Order>> => {
    const token = getToken();
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Orders.get(token, orderId, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  const checkCredits = async () => {
    const token = getToken();
    let resp;
    console.log("test 2");

    try {
      resp = await Orders.credits(token);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  return {
    getOrders,
    // getSubmissionsFinite,
    getOrder,
    checkCredits,
  };
};

export default useOrders;
